<div class="game-container">
  <canvas #renderCanvas touch-action="none"></canvas>

  <div id="diamonds" (click)="toggleGiftersList()">
    <ng-container *ngIf="userData; else loginPrompt">
       🏵️ {{ userData.diamonds }}
    </ng-container>
    <ng-template #loginPrompt>
      Đăng nhập
    </ng-template>
  </div>

  <div class="top-actions">
    <div id="csytDiv" *ngIf="csyt && !showGifterScene" (click)="navigateToQlyHoSo()">
      Hồ sơ
    </div>
    <div class="payment-action" *ngIf="payCenter && !showGifterScene" (click)="navigatePaymentCenter()">
      Thanh toán
    </div>
    <div class="qlyUser" *ngIf="member && !showGifterScene" (click)="navigateToQlyThanhVien()">
      Thành viên
    </div>
  </div>

  <!-- Dropdown Menu Gifters -->
  <div *ngIf="showGiftersList && userData" class="gifters-dropdown">
    <div class="gifters-menu">
      <div class="menu-header" (click)="openGifterScene()">
        <span>Người tặng</span>
      </div>
      
      <div class="menu-items">
        <div *ngIf="sortedGifters.length === 0" class="menu-item no-gifters">
          Chưa có ai tặng quà
        </div>
        
        <div *ngFor="let gifter of sortedGifters" 
             class="menu-item gifter-item" 
             (click)="showGifterDetail(gifter); $event.stopPropagation()">
          <div class="gifter-content">
            <span class="gifter-name">{{ getDisplayName(gifter.email) }}</span>
            <span *ngIf="!gifter.seen" class="unseen-dot"></span>
          </div>
          <div class="gifter-time">{{ formatTime(gifter.lastSent) }}</div>
        </div>
      </div>
      
      <div class="menu-footer">
        <div class="menu-item signout-item" (click)="signOut(); $event.stopPropagation()">
          <span>Đăng xuất</span>
        </div>
      </div>
    </div>
  </div>

    
  <div *ngIf="gameOverDiv" class="game-over">
    <button (click)="replay()">Đánh giá lại</button>
    <div *ngIf="!outputPlanData">
      <h2>Tình trạng sức khỏe</h2>      
      <ul>
        <li *ngFor="let problem of plansProblem">
          <span>{{ problem.name }}</span>
          <span class="container-status">          
            <span *ngIf="problem.option == 1" class="dot-status green"></span>         
            <span *ngIf="problem.option == 2" class="dot-status cyan"></span>
            <span *ngIf="problem.option == 3" class="dot-status yellow"></span>
            <span *ngIf="problem.option == 4" class="dot-status orange"></span>
            <span *ngIf="problem.option == 5" class="dot-status red"></span>
          </span>
        </li>
      </ul>
    </div>

    <div *ngIf="outputPlanData">
      <div *ngIf="outputPlanData.diagnosis">
        <h3>Chẩn đoán</h3>
        <p>{{ outputPlanData.diagnosis }}</p>
      </div>
      <div *ngIf="outputPlanData.guide?.length">
        <h3>Hướng dẫn</h3>
        <ul class="left-aligned-list">
          <li *ngFor="let guide of outputPlanData.guide">
            {{ guide }}
          </li>
        </ul>
      </div>
      <div *ngIf="outputPlanData.lab?.length">
        <h3>Xét nghiệm cần làm</h3>
        <ul class="left-aligned-list">
          <li *ngFor="let lab of outputPlanData.lab">
            {{ lab }}
          </li>
        </ul>
      </div>
      <div *ngIf="outputPlanData.medications?.length">
        <h3>Thuốc</h3>
        <ul class="left-aligned-list">
          <li *ngFor="let med of outputPlanData.medications">
            <strong>{{ med.brandName }}</strong> - 
            Số lượng: {{ med.quantity }} - 
            Hướng dẫn: {{ med.use }}
          </li>
        </ul>
      </div>      
      <div *ngIf="outputPlanData.remark">
        <h3>Ghi chú</h3>
        <p>{{ outputPlanData.remark }}</p>
      </div>
    </div>

    <button *ngIf="buttonFind" (click)="getGptGuide()">Xem hướng dẫn</button>
    <button *ngIf="!buttonFind" (click)="callDoctor()">Liên hệ khẩn cấp</button>
  </div>

  <div class="invite-button-container" *ngIf="!showGifterScene">
    <button class="invite-button" (click)="requestEmergencyService()">
      Free
    </button>
  </div>

  <div class="bottom-actions" *ngIf="!showGifterScene "> 
    <button class="farm-button" (click)="toggleLichSuDv()">
      Y bạ
    </button>
    <button class="farm-button" (click)="toggleDanhSachDv()">
      Dịch vụ
    </button>
    <button class="farm-button" (click)="navigateToFarm()">
      Sản phẩm
    </button>
  </div>

</div>

<app-mission 
  *ngIf="missionChild && !gameOverDiv"
  [userDocRef]="userDocRef"
  [userDiamonds]="userData.diamonds"
  >
</app-mission>

<app-gifter-detail
  *ngIf="selectedGifter"
  [selectedGifter]="selectedGifter"
  [selectedGifterInfo]="selectedGifterInfo"
  [formatTime]="formatTime"
  (close)="closeGifterDetail()"
  >
</app-gifter-detail>

<app-danhSachDichVu  
  [userData]="userData" 
  [userDocRef]="userDocRef" 
  [hidden]="!danhSachDv"
  >
</app-danhSachDichVu>

<app-lichSuDichVu 
  #userDetail
  *ngIf="lichSuDv"  
  [userEmail]="userData?.email"
  >
</app-lichSuDichVu>

<app-invite-friends 
  *ngIf="userData && !gameOverDiv && !danhSachDv && !lichSuDv"
  [userData]="userData" 
  [userDocRef]="userDocRef"
  >
</app-invite-friends>

<app-gifter-scene
  *ngIf="showGifterScene && userData.diamonds > 5000"
  [engine]="gameEngine"
  [scene]="gameScene"
  [userData]="userData"
  (backButtonClicked)="returnToHomeView()"
  >
</app-gifter-scene>
